import React from 'react';
import { Users, Settings, CreditCard, LineChart, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import MetricCard from "@/components/dashboard/MetricCard";
import DashboardSection from "@/components/dashboard/DashboardSection";
import ResponsiveContainer from "@/components/dashboard/ResponsiveContainer";

const AdminDashboard = () => {
  const metrics = [
    { 
      icon: <Users className="h-5 w-5 sm:h-6 sm:w-6" />, 
      label: "Total Users", 
      value: "156",
      trend: { value: 12, isPositive: true }
    },
    { 
      icon: <LineChart className="h-5 w-5 sm:h-6 sm:w-6" />, 
      label: "Active Teams", 
      value: "24",
      trend: { value: 8, isPositive: true }
    },
    { 
      icon: <CreditCard className="h-5 w-5 sm:h-6 sm:w-6" />, 
      label: "Monthly Revenue", 
      value: "$12.5k",
      trend: { value: 5, isPositive: true }
    },
    { 
      icon: <Settings className="h-5 w-5 sm:h-6 sm:w-6" />, 
      label: "System Health", 
      value: "98%",
      trend: { value: 0.5, isPositive: true }
    }
  ];

  return (
    <ResponsiveContainer>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">Admin Dashboard</h2>
        <Button size="sm" className="w-full sm:w-auto">
          <Plus className="mr-2 h-4 w-4" /> Add New User
        </Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {metrics.map((metric, index) => (
          <MetricCard key={index} {...metric} />
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        <DashboardSection
          title="Recent Activities"
          description="Latest system activities and updates"
          action={<Button variant="outline" size="sm" className="w-full sm:w-auto">View All</Button>}
        >
          <div className="space-y-3 sm:space-y-4">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between py-2 gap-2">
              <div>
                <p className="font-medium">New Coach Registration</p>
                <p className="text-xs sm:text-sm text-muted-foreground">2 minutes ago</p>
              </div>
              <Button variant="ghost" size="sm" className="w-full sm:w-auto">Review</Button>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between py-2 gap-2">
              <div>
                <p className="font-medium">Payment System Update</p>
                <p className="text-xs sm:text-sm text-muted-foreground">1 hour ago</p>
              </div>
              <Button variant="ghost" size="sm" className="w-full sm:w-auto">Details</Button>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between py-2 gap-2">
              <div>
                <p className="font-medium">New Team Created</p>
                <p className="text-xs sm:text-sm text-muted-foreground">3 hours ago</p>
              </div>
              <Button variant="ghost" size="sm" className="w-full sm:w-auto">View</Button>
            </div>
          </div>
        </DashboardSection>

        <DashboardSection
          title="System Overview"
          description="Platform performance and statistics"
          action={<Button variant="outline" size="sm" className="w-full sm:w-auto">Settings</Button>}
        >
          <div className="space-y-4">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
              <div className="w-full sm:w-3/4 space-y-1">
                <p className="text-sm font-medium">Storage Usage</p>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-blue-600 h-2 rounded-full" style={{ width: '45%' }}></div>
                </div>
              </div>
              <span className="text-sm font-medium">45%</span>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
              <div className="w-full sm:w-3/4 space-y-1">
                <p className="text-sm font-medium">API Usage</p>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-green-600 h-2 rounded-full" style={{ width: '72%' }}></div>
                </div>
              </div>
              <span className="text-sm font-medium">72%</span>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
              <div className="w-full sm:w-3/4 space-y-1">
                <p className="text-sm font-medium">Database Load</p>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-orange-600 h-2 rounded-full" style={{ width: '85%' }}></div>
                </div>
              </div>
              <span className="text-sm font-medium">85%</span>
            </div>
          </div>
        </DashboardSection>
      </div>
    </ResponsiveContainer>
  );
};

export default AdminDashboard; 